// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.store/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.svg-icon[data-v-c8a70580] {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.svg-external-icon[data-v-c8a70580] {\n  background-color: currentColor;\n  -webkit-mask-size: cover !important;\n          mask-size: cover !important;\n  display: inline-block;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
